import type { JSX } from 'react';
import type { Product } from '@/types/Product.types';
import { updatedImageUrl } from '@/utils/formatting';
import styles from '../ApprovalPortalPage.module.css';

interface ProductCardProps {
  product: Product;
}

export const ProductCard = ({ product }: ProductCardProps): JSX.Element => {
  return (
    <div className={styles.productCard}>
      <div className={styles.productImageWrapper}>
        <img
          src={updatedImageUrl(product.imageUrl) || '/placeholder.png'}
          alt={product.name}
          className={styles.productImage}
          loading="lazy"
        />
      </div>
      <div className={styles.productInfo}>
        <p className={styles.productName}>{product.name || 'Product'}</p>
        <p className={styles.productBrand}>{product.brand || ''}</p>
        <p className={styles.productPrice}>
          {product.discountPrice ? (
            <>
              <span className={styles.discountPrice}>
                ₹{product.discountPrice}
              </span>
              <span className={styles.originalPrice}>₹{product.price}</span>
            </>
          ) : (
            <span>₹{product.price}</span>
          )}
        </p>
        <a
          href={product.productLink}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.productLink}
        >
          View Product
        </a>
      </div>
    </div>
  );
};
